import { ColumnDetails } from '../../../grid/types/common';
import { AccountAction, Column, ColumnKeys, MobileSecurityAccountStatus } from '../types';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { ButtonHeights, ButtonTypes } from '../../../ui/gzButton/types';
import { WEB_COMPONENT_GZ_PROGRESS_SPINNER } from '../../../webcomponents.constants';
import { GzProgressSpinnerWebComponent } from '../../../ui/gzProgressSpinner';
import { SpinnerWidth } from '../../../ui/gzProgressSpinner/types';

export function mobileSecurityAccountActionsRenderer(translations: any, element: HTMLElement) {
  return (rowData: Record<string, Object>, _: ColumnDetails<Column, ColumnKeys>) => {
    const companyId = rowData.item['_id'];
    const accountStatus = rowData.item[ColumnKeys.MOBILE_SECURITY_ACCOUNT_STATUS];

    const container = document.createElement('div');
    container.style['width'] = '100%';
    container.style['display'] = 'flex';
    container.style['align-items'] = 'center';
    container.style['justify-content'] = 'start';

    const padding = document.createElement('div');
    padding.style['width'] = '30%';
    padding.style['flex-shrink'] = '1';
    container.appendChild(padding);

    const iconContainer = document.createElement('div');
    iconContainer.style['display'] = 'inline-flex';
    container.appendChild(iconContainer);

    const dispatchEvent = (type: AccountAction) => {
      element.dispatchEvent(
        new CustomEvent(type, {
          detail: {
            id: companyId,
            name: rowData.item[ColumnKeys.MOBILE_SECURITY_COMPANY_NAME],
            fromCustomerView: false,
          },
          bubbles: true,
          composed: true,
        })
      );
    };

    switch (accountStatus) {
      case MobileSecurityAccountStatus.NOT_CREATED:
        container.appendChild(
          buildButton(AccountAction.CREATE, companyId, translations, () => dispatchEvent(AccountAction.CREATE))
        );
        break;

      case MobileSecurityAccountStatus.CREATED:
        container.appendChild(
          buildButton(AccountAction.CONSOLE, companyId, translations, () => dispatchEvent(AccountAction.CONSOLE))
        );

        container.appendChild(
          buildButton(AccountAction.ACTIVATION, companyId, translations, () => dispatchEvent(AccountAction.ACTIVATION))
        );

        container.appendChild(buildHiddenActionSpinner(companyId));
        break;

      case MobileSecurityAccountStatus.EXPIRED:
        const tooltipText = getExpiredTooltipText(translations, rowData.item['daysUntilExpire']);

        iconContainer.innerHTML = `<gz-tooltip style="display: inline-flex" tooltiptext="${tooltipText}" id="expired-tooltip">
            <gz-icon name="ds-icon-notification_warning" color="warning" size="20"></gz-icon>
          </gz-tooltip>`;

        const button = buildButton(AccountAction.CONSOLE, companyId, translations, () =>
          dispatchEvent(AccountAction.CONSOLE)
        );
        button.disabled = true;

        container.appendChild(button);
        break;
    }

    return container;
  };
}

function buildButton(
  action: AccountAction,
  companyId: string,
  translations: any,
  callback: () => void
): GzButtonWebComponent {
  const actionToLabelMap = {
    [AccountAction.CREATE]: translations.createAccount,
    [AccountAction.CONSOLE]: translations.openConsole,
    [AccountAction.ACTIVATION]: translations.sendActivationLinks,
  };

  const button = document.createElement('gz-button') as GzButtonWebComponent;

  button.id = `${action}-${companyId}`;
  button.type = ButtonTypes.QUIET;
  button.buttonHeight = ButtonHeights.SMALL;
  button.innerText = actionToLabelMap[action];
  button.disabled = false;
  button.lowercase = true;
  button.style['margin'] = '0px 10px';

  button.addEventListener('click', callback);

  return button;
}

export function getExpiredTooltipText(translations: any, daysUntilExpire: number | undefined) {
  if (!daysUntilExpire)
    return translations.licenseNotValid;

  return daysUntilExpire <= 1
    ? translations.licenseNotValidExpiringToday
    : translations.licenseNotValidWithDaysLeft(daysUntilExpire);
}

function buildHiddenActionSpinner(companyId: string) {
  const spinner = document.createElement(WEB_COMPONENT_GZ_PROGRESS_SPINNER) as GzProgressSpinnerWebComponent;

  spinner.id = `spinner-${companyId}`;
  spinner.indeterminate = true;
  spinner.spinnerWidth = SpinnerWidth.SMALL;
  spinner.style.display = 'none';
  spinner.style.margin = '0px 10px';

  return spinner;
}
